/**
 * External dependencies
 */
import { reduce, size } from 'lodash';

/**
 * Internal filters
 */
import getFilters from './get-filters';

export default (state) =>
	reduce(
		getFilters(state),
		(sum, filter) => {
			return sum + size(filter.values);
		},
		0,
	);
